import * as $ from 'jquery';
import 'owl.carousel';

let $slideshow = $('.slideshow');

if($slideshow.length > 0) {
  $slideshow.owlCarousel({
    autoplay:        false,
    items:           1,
    autoHeight:      true,
    mouseDrag:       true,
    touchDrag:       true,
    nav:             false,
    dots:            true,
    loop:            true,

    onInitialized: (function() {
        this.$element.addClass('owl-carousel');
        this.$element.find('.cloned, .owl-dots, .owl-nav').attr({
            'aria-hidden': true,
            'role'       : 'presentation',
        });

        this.$element.find('.slideshow__prev').click(function(e){
            e.preventDefault();
            $(this).closest('.slideshow').trigger('prev.owl.carousel');
        });

        this.$element.find('.slideshow__next').click(function(e){
            e.preventDefault();
            $(this).closest('.slideshow').trigger('next.owl.carousel');
        });

        this.$element.find('img').on('load', function(e) {
          $(this).closest('.slideshow').trigger('refresh.owl.carousel');
        });
    }),
  });
}
